const FETCH_USER_PERMISSIONS_REQUEST = 'FETCH_USER_PERMISSIONS_REQUEST';
const FETCH_USER_PERMISSIONS_SUCCESS = 'FETCH_USER_PERMISSIONS_SUCCESS';
const FETCH_USER_PERMISSIONS_FAILURE = 'FETCH_USER_PERMISSIONS_FAILURE';

export const userPermissionsActionTypes = {
    FETCH_USER_PERMISSIONS_REQUEST,
    FETCH_USER_PERMISSIONS_SUCCESS,
    FETCH_USER_PERMISSIONS_FAILURE,
};
